<template>
  <div class="noticeList w w1200">
    <el-breadcrumb
      separator-class="el-icon-arrow-right"
      class="breakcrumbHeader">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>公告消息</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="list" v-if="total">
      <el-collapse v-model="activeNames" accordion @change="handleChange">
        <el-collapse-item :name="notice.id" v-for="notice in noticeList" :key="notice.id">
          <template slot="title">
            <div class="title">
              <el-tag size="mini" effect="dark" :type="notice.currUserRead === 'Y' ? 'info' : 'danger'">{{notice.currUserRead === 'Y' ? '已读' : '未读'}}</el-tag>
              <span>{{notice.title}}</span>
            </div>
          </template>
          <div class="content">{{notice.detail}}</div>
          <div class="time">{{notice.gmtStart | formatTime('yyyy/MM/dd')}}</div>
        </el-collapse-item>
      </el-collapse>
      <!-- 分页组件 -->
      <Pagination v-bind:child-msg="{
        pageSize,
        currentPage: pageIndex,
        total
      }" @callFather="callFather"></Pagination>
    </div>
    <empty v-else>暂无公告消息</empty>
  </div>
</template>

<script type="text/ecmascript-6">
import {fetchNoticeList, fetchReadNotice} from '../../api/xunyou';
import Pagination from "@/components/Pagination";
export default {
  name: 'noticeList',
  components: {
    Pagination
  },
  data() {
    return {
      loading: false,
      total: 0,
      pageIndex: 1,
      pageSize: 10,
      noticeList: [],
      activeNames: []
    }
  },
  created () {
    this.search();
  },
  beforeDestroy() {
    this.$store.dispatch('getUnreadCount');
  },
  methods: {
    handleChange (val) {
      console.log(val);
      const curNotice = this.noticeList.find(ele => ele.id === val);
      if (curNotice.currUserRead === 'Y') return ;
      fetchReadNotice({ noticeNo: curNotice.noticeNo }).then(res => {
        console.log('已读：', res);
        if (res.code === this.$code) {
          curNotice.currUserRead = 'Y';
        }
      });
    },
    // 查询
    search () {
      this.pageIndex = 1;
      this.pageSize = 10;
      this.getNoticeList();
    },
    // 分页插件事件
    callFather(parm) {
      this.pageIndex = parm.currentPage;
      this.pageSize = parm.pageSize;
      this.getNoticeList();
    },
    getNoticeList () {
      const params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      fetchNoticeList(params).then(res => {
        console.log('公告消息：', res);
        if (res.code === this.$code) {
          this.total = res.data.total;
          this.noticeList = res.data.rows;
        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" rel="stylesheet/less" scoped>
.title{
  padding: 0 10px;
}
.content{
  text-indent: 2em;
  margin: 0 10px;
  padding: 10px;
  border-radius: 6px;
  background-color: #F5F5F5;
}
.time{
  font-size: 12px;
  color: #999;
  text-align: right;
  padding-right: 10px;
}
/deep/ .el-collapse{
  border-color: transparent;
  .el-collapse-item{
    margin-bottom: 15px;
    border-radius: 6px;
    .el-collapse-item__wrap, .el-collapse-item__header{
      border-bottom: none;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/noticeList/noticeList.vue